import { Login, LoginKalyzeeAdapter } from "@kalyzee/kast-web-sdk/adapted-web-components";
import { AppVersion, AuthenticationMethod, AuthenticationResult, delay, Touchable } from "@kalyzee/kast-web-sdk/web-components";

import { sdkClient } from "../../../helpers/sdk";
import { useAppDispatch } from "../../../hooks/app";
import { login } from "../../../store/session/slices";
import styles from "./login.module.css";
import "./login.css";
import { useDisableGoogleLogin } from "../../../store/session/hooks";
import { toastError } from "../../../helpers/toast";
import { useEffect, useState } from "react";
import { ButtonFinal, DateTimeDisplay } from "@kalyzee/escaet-ui";

import SamiiEscaetLogo from "../../../assets/logo/samii-escaet.svg";
import { ReactComponent as BackIcon } from "../../../assets/icons/back-login.svg";

export interface LoginPageProps {}

const LoginPage = ({}: LoginPageProps) => {
  const dispatch = useAppDispatch();
  const disableGoogleLogin = useDisableGoogleLogin();

  const [oAuthError, setOAuthError] = useState<boolean>();
  const [authMethod, setAuthMethod] = useState<'credentials' | 'google'>('google');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('backend_error');
    if (error) {
      setOAuthError(true);
      console.error('Error while authenticating with Google: ', error);
    }
  }, []);

  const onResult = async (result: AuthenticationResult) => {
    if (result.success) {
      const tokens = result.tokens;
      if (tokens?.token) {
        dispatch(login({ token: tokens.token, refreshToken: tokens.refreshToken }));
      }
    } else {
      toastError("Identifiants incorrects")
    }
  };

  const renderAuthGoogle = () => {
    return (
      <div style={{ 
        maxWidth: 350, 
        width: "80%", 
        alignItems: 'left', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1em',
      }}>
        <Login
          className="login"
          style={{ width: '100%', height: "unset", color: "black" }}
          sdk={sdkClient}
          logo={null}
          methods={[AuthenticationMethod.Google]}
          oAuthRedirectUri={window.origin}
          onResult={onResult}
          googleAuthentificationProps={oAuthError ? {
            error: 'Une erreur est survenue',
          } : undefined}
          localAuthentificationProps={{
            placeholderEmail: 'Email',
            placeholderPassword: 'Mot de passe'             
          }}
        />
        <ButtonFinal
          text="Utiliser mes identifiants"
          background="#4b4b4b"
          cx="!text-white !py-[20px] !w-full !rounded-[10px] !font-bold !text-[16px]"
          onClick={() => setAuthMethod('credentials')}
        />
      </div>
    );
  };

  const renderAuthCredentials = () => {
    return (
      <div style={{ 
        maxWidth: 550, 
        borderRadius: 12,
        width: "80%", 
        alignItems: 'left', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1em',
        backgroundColor: 'white', 
        padding: 80,
      }}>
        <Touchable 
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.5em',
            paddingBottom: '1.5em',
          }}
          onClick={() => setAuthMethod('google')}
        >
          <BackIcon />
          <div className={styles.backButtonText}>Retour</div>
        </Touchable>
        <div className={styles.myCredentialsTitle}>Utiliser mes identifiants</div>
        <Login
          className="login"
          style={{ width: '100%', height: "unset", color: "black" }}
          sdk={sdkClient}
          logo={null}
          methods={[AuthenticationMethod.Local]}
          oAuthRedirectUri={window.origin}
          onResult={onResult}
          googleAuthentificationProps={oAuthError ? {
            error: 'Une erreur est survenue',
          } : undefined}
          localAuthentificationProps={{
            placeholderEmail: 'Email',
            placeholderPassword: 'Mot de passe'             
          }}
        />
      </div>
    );
  };

  const renderAuth = () => {
    if (authMethod === 'google' && !disableGoogleLogin) {
      return renderAuthGoogle();
    }
    return renderAuthCredentials();
  }

  return (
    <div className={styles.backgroundHome}>
      <div className={styles.headerHome}>
        <img src={SamiiEscaetLogo} alt="logo" />
      </div>
      <div className={styles.mainHome}>
        {renderAuth()}
      </div>
      <div className={styles.footerHome}>
        <DateTimeDisplay cx="textLeft" />
      </div>
      <AppVersion />
    </div>
  );
};

export default LoginPage;
